import { useState } from "react";
import styles from "./index.module.scss";
import { useTranslations } from "next-intl";

interface ToggleProps {
  onChange?: (value: "phone" | "email") => void;
}

export default function ToggleEmailPhone({ onChange }: ToggleProps) {
  const [active, setActive] = useState<"phone" | "email">("phone");
  const t = useTranslations("ToggleEmailPhone"); // используем только этот t

  const handleToggle = (value: "phone" | "email") => {
    setActive(value);
    onChange?.(value);
  };

  return (
    <div className={styles.container}>
      <div
        className={`${styles.item} ${active === "phone" ? styles.active : ""}`}
        onClick={() => handleToggle("phone")}
      >
        <span className={`${styles.item__title} ${styles.phone}`}>{t("phone")}</span>
      </div>

      <div
        className={`${styles.item} ${active === "email" ? styles.active : ""}`}
        onClick={() => handleToggle("email")}
      >
        <span className={`${styles.item__title} ${styles.email}`}>{t("email")}</span>
      </div>
    </div>
  );
}
